import { useParams } from "react-router-dom";
import { fetchGroupCollectionByIdService } from "../../services/groupService";
import { useEffect, useState } from "react";
import {
  Box,
  Chip,
  Grid,
  Modal,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

function ViewGroupDetails() {
  const { id } = useParams();
  const [groupDetails, setGroupDetails] = useState();
  const [groupCollections, setGroupCollections] = useState([]);
  const [groupPigmyCollections, setGroupPigmyCollections] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [selectedPaymentDetails, setSelectedPaymentDetails] = useState(null);

  const handleOpenModal = (details) => {
    setSelectedPaymentDetails(details);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedPaymentDetails(null);
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await fetchGroupCollectionByIdService(id);
        setGroupDetails(response?.group);
        setGroupCollections(response?.groupCollection);
        setGroupPigmyCollections(response?.groupPigmyCollection);
        console.log(response?.groupCollection);
      } catch (error) {
        console.error("Failed to fetch loan details:", error);
      }
    };

    fetchDetails();
  }, [id]);

  return (
    <>
      {" "}
      <Paper
        elevation={3}
        sx={{
          padding: "20px",
          borderRadius: "12px",
          backgroundColor: "#f9f9f9",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "bold", color: "#3f51b5" }}
      >
        Loan Details
      </Typography> */}

        <Grid container spacing={3}>
          {[
            { label: "Group Code", value: groupDetails?.groupCode },
            {
              label: "Group Leader Phone Number",
              value: groupDetails?.groupLeaderPhoneNumber,
            },
            { label: "Agent Name", value: groupDetails?.agent?.userName },
            { label: "Agent Code", value: groupDetails?.agent?.code },
            { label: "Frequency", value: groupDetails?.frequency },
            { label: "Loan Tenure ", value: groupDetails?.loanTenure },
            { label: "Loan Amount", value: `₹${groupDetails?.loanAmount}` },
            {
              label: "Interest Amount",
              value: `₹${groupDetails?.interestAmount}`,
            },
            {
              label: "Processing Fee",
              value: `₹${groupDetails?.processingFee}`,
            },
            {
              label: "Disbursed Amount",
              value: `₹${groupDetails?.disbursedAmount}`,
            },
            {
              label: "Remaining Amount",
              value: `₹${groupDetails?.remainingAmount}`,
            },
            // {
            //   label: "Penalty Amount",
            //   value: `₹${groupDetails?.penaltyAmount}` || 0,
            // },
            {
              label: "Start Date",
              value: moment(groupDetails?.startDate).format("DD-MM-YYYY"),
            },
            {
              label: "End Date",
              value: moment(groupDetails?.endDate).format("DD-MM-YYYY"),
            },
            { label: "Loan Status", value: groupDetails?.loanStatus },
            {
              label: "Total Received Amount",
              value: `₹${groupDetails?.totalReceivedAmount}`,
            },
            {
              label: "Total Interest Paid",
              value: `₹${groupDetails?.totalInterestAmountPaid}`,
            },
            {
              label: "Total Penalty Paid",
              value: `₹${groupDetails?.totalPenaltyAmount}`,
            },
            {
              label: "Total Pigmy Received",
              value: `₹${groupDetails?.pigmySavings}`,
            },
            // {
            //   label: "Total Penalty Paid",
            //   value: `₹${groupDetails?.totalPenaltyAmountPaid}` || 0,
            // },
            {
              label: "Amount to be Paid By",
              value: groupDetails?.amountToBePaidBy,
            },
            { label: "Total Members", value: groupDetails?.users.length },
            // { label: "Insurance Fee", value: `₹${groupDetails?.insuranceFee}` },
          ].map((item, index) => (
            <Grid item xs={12} sm={3} key={index}>
              <Typography
                variant="body2"
                sx={{ fontWeight: "bold", color: "#555" }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: "#333", marginTop: "4px" }}
              >
                {item.label === "Loan Status" ? (
                  <Chip
                    label={item.value}
                    sx={{
                      bgcolor: item.value === "Active" ? "green" : "red",
                      color: "white",
                    }}
                  />
                ) : (
                  item.value || "N/A"
                )}
              </Typography>
            </Grid>
          ))}
          {/* User Details */}
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{ marginTop: "10px", fontWeight: "bold", color: "#3f51b5" }}
            >
              Group Members
            </Typography>
          </Grid>

          {groupDetails?.users?.map((user, index) => (
            <Grid item xs={12} sm={4} md={3} key={index}>
              <Paper
                elevation={2}
                sx={{ padding: "10px", backgroundColor: "#ffffff" }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: "bold", color: "#555" }}
                >
                  Name: {user?.userName || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Phone Number: {user?.primaryPhone?.contactValue || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Loan Amount: {user?.loan?.loanAmount || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Collection Amount: {user?.loan?.collectionAmount || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Penalty Amount: {user?.loan?.totalPenaltyAmountPaid || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Interest Amount:{" "}
                  {user?.loan?.totalInterestAmountPaid || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Total Received Amount:{" "}
                  {user?.loan?.totalReceivedAmount || "N/A"}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#333", marginTop: "4px" }}
                >
                  Pigmy Savings: {user?.pigmySavings?.pigmySavings || "N/A"}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Paper>
      <Paper
        elevation={3}
        sx={{ borderRadius: "12px", overflow: "hidden", marginTop: 5 }}
      >
        {/* Tabs Header */}
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          centered
        >
          <Tab label="Loan Collection" />
          <Tab label="Pigmy Collection" />
        </Tabs>

        {/* Tabs Content */}
        {activeTab === 0 ? (
          <div>
            <TableContainer>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Loan Code
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Collection Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Interest Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Due Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Collected Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Paid Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Penalty / Interest Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Due By
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Status
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupCollections?.map((collection, index) => (
                    <TableRow
                      key={collection._id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                      }}
                    >
                      <TableCell>{collection?.groupId?.groupCode}</TableCell>
                      <TableCell>{collection?.collectionAmount}</TableCell>
                      <TableCell>{collection.interestAmount}</TableCell>
                      <TableCell>
                        {moment(collection.dueDate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {collection?.collectionDate
                          ? moment(collection.collectionDate).format(
                              "DD-MM-YYYY"
                            )
                          : "-"}
                      </TableCell>
                      <TableCell>{collection.paidAmount}</TableCell>
                      <TableCell>
                        {collection?.groupId?.frequency === "monthly"
                          ? collection.paidInterest
                          : collection.paidPenalty}
                      </TableCell>
                      <TableCell>{collection.dueBy}</TableCell>
                      <TableCell
                        sx={{
                          color:
                            collection.status === "paid"
                              ? "green"
                              : collection.status === "partial"
                              ? "#8B8000"
                              : "red",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {collection.status === "paid" ? (
                          <>
                            <CheckCircleIcon sx={{ mr: 1 }} /> Paid
                          </>
                        ) : collection.status === "partial" ? (
                          <>
                            <CancelIcon sx={{ mr: 1 }} /> Partial Payment
                          </>
                        ) : (
                          <>
                            <CancelIcon sx={{ mr: 1 }} /> Unpaid
                          </>
                        )}
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                        <InfoOutlined
                          color="primary"
                          onClick={() => handleOpenModal(collection)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          <div>
            <TableContainer>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Pigmy Code
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Collection Amount
                    </TableCell>

                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Due Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Collected Date
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Paid Amount
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Due By
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Status
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "#3f51b5" }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groupPigmyCollections?.map((collection, index) => (
                    <TableRow
                      key={collection._id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "white",
                      }}
                    >
                      <TableCell>{collection?.groupId?.groupCode}</TableCell>
                      <TableCell>{collection?.collectionAmount}</TableCell>

                      <TableCell>
                        {moment(collection.dueDate).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {collection?.collectionDate
                          ? moment(collection.collectionDate).format(
                              "DD-MM-YYYY"
                            )
                          : "-"}
                      </TableCell>
                      <TableCell>{collection.paidAmount}</TableCell>
                      <TableCell>{collection.dueBy}</TableCell>
                      <TableCell
                        sx={{
                          color:
                            collection.status === "Paid"
                              ? "green"
                              : collection.status === "partial"
                              ? "#8B8000"
                              : "red",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {collection.status === "Paid" ? (
                          <>
                            <CheckCircleIcon sx={{ mr: 1 }} /> Paid
                          </>
                        ) : collection.status === "partial" ? (
                          <>
                            <CancelIcon sx={{ mr: 1 }} /> Partial Payment
                          </>
                        ) : (
                          <>
                            <CancelIcon sx={{ mr: 1 }} /> Unpaid
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </Paper>
      {/* Modal for Payment Details */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxWidth: 800,
            width: "90%",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Payment Details
          </Typography>

          {selectedPaymentDetails ? (
            <Box>
              <Grid container spacing={2}>
                {/* Total Paid and EMI */}
                <Grid item xs={12}>
                  <Typography variant="body2">
                    EMI Collection Amount:{" "}
                    {selectedPaymentDetails?.collectionAmount || "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    Total Paid Amount:{" "}
                    {selectedPaymentDetails?.paidAmount || "N/A"}
                  </Typography>
                </Grid>

                {/* Chips for Penalty Paid and Interest Paid */}
                <Grid item xs={12} sm={6}>
                  <Chip
                    label={`Penalty Paid: ${
                      selectedPaymentDetails?.paidPenalty || "N/A"
                    }`}
                    color="secondary"
                    variant="outlined"
                    sx={{ width: "100%" }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Chip
                    label={`Interest Paid: ${
                      selectedPaymentDetails?.paidInterest || "N/A"
                    }`}
                    color="primary"
                    variant="outlined"
                    sx={{ width: "100%" }}
                  />
                </Grid>
              </Grid>

              {/* Member Loan Details with Scroll */}
              <Box
                sx={{
                  mt: 3,
                  maxHeight: 300, // Limit height to 300px
                  overflowY: "auto", // Add scroll if content overflows
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  p: 1,
                }}
              >
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Member Loan Details:
                </Typography>
                {selectedPaymentDetails.memberLoanIds?.length > 0 ? (
                  selectedPaymentDetails.memberLoanIds.map((loan, index) => (
                    <Box
                      key={loan._id}
                      sx={{
                        mb: 2,
                        p: 2,
                        border: "1px solid #ccc",
                        borderRadius: 1,
                        backgroundColor: "#fafafa",
                      }}
                    >
                      <Typography variant="body2">Loan #{index + 1}</Typography>
                      <Typography variant="body2">
                        Name: {loan.user?.userName || "N/A"}
                      </Typography>
                      <Typography variant="body2">
                        Loan Type: {loan.loanType || "N/A"}
                      </Typography>
                      <Typography variant="body2">
                        Paid Amount: {loan.paidAmount || 0}
                      </Typography>
                      <Box
                        sx={{
                          mt: 1,
                          display: "flex",
                          gap: 1,
                          flexWrap: "wrap",
                        }}
                      >
                        <Chip
                          label={`Interest Paid: ${
                            loan.paidInterestAmount || 0
                          }`}
                          color="primary"
                          variant="outlined"
                        />
                        <Chip
                          label={`Penalty Paid: ${loan.paidPenaltyAmount || 0}`}
                          color="secondary"
                          variant="outlined"
                        />
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2">
                    No member loan details available.
                  </Typography>
                )}
              </Box>
            </Box>
          ) : (
            <Typography variant="body2">
              No payment details available.
            </Typography>
          )}
        </Box>
      </Modal>
    </>
  );
}

export default ViewGroupDetails;
